import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../utils/api.js';
import { API_ENDPOINTS } from '../config/api.js';
import AuthForm from '../components/AuthForm.jsx';

const ForgotPasswordPage = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [resetToken, setResetToken] = useState('');

  const handleSubmit = async (formData) => {
    setLoading(true);
    setError('');
    setSuccess(false);
    
    try {
      const response = await api.post(API_ENDPOINTS.FORGOT_PASSWORD, { 
        email: formData.email 
      });
      
      setSuccess(true);
      if (response.resetToken) {
        setResetToken(response.resetToken);
      }
    } catch (err) {
      setError(err.data?.error || err.message || 'Failed to send reset link');
    }
    
    setLoading(false);
  };

  const fields = [
    {
      name: 'email',
      label: 'Email',
      type: 'email',
      placeholder: 'you@example.com',
      required: true
    }
  ];

  const footer = (
    <div>
      Remember your password?{' '}
      <Link to="/login" style={{ color: '#60a5fa', textDecoration: 'none' }}>
        Sign in
      </Link>
    </div>
  );

  if (success) {
    return (
      <div style={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        fontFamily: '"DM Sans", system-ui, sans-serif'
      }}>
        <div style={{
          background: 'rgba(30, 41, 59, 0.8)',
          borderRadius: '16px',
          border: '1px solid rgba(100, 116, 139, 0.3)',
          padding: '3rem',
          width: '100%',
          maxWidth: '420px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          textAlign: 'center'
        }}>
          <div style={{
            width: '60px',
            height: '60px',
            background: 'rgba(34, 197, 94, 0.2)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 1.5rem',
            fontSize: '2rem'
          }}>
            ✓
          </div>
          
          <h1 style={{
            fontSize: '1.5rem',
            fontWeight: '700',
            marginBottom: '1rem',
            color: '#e2e8f0'
          }}>
            Check Your Email
          </h1>
          
          <p style={{
            color: '#94a3b8',
            marginBottom: '1.5rem'
          }}>
            If an account exists with that email, we've sent password reset instructions.
          </p>

          {resetToken && (
            <div style={{
              background: 'rgba(59, 130, 246, 0.1)',
              border: '1px solid rgba(59, 130, 246, 0.3)',
              borderRadius: '8px',
              padding: '1rem',
              marginBottom: '1.5rem'
            }}>
              <div style={{ color: '#94a3b8', fontSize: '0.75rem', marginBottom: '0.5rem' }}>
                Development Mode - Reset Token:
              </div>
              <div style={{ 
                color: '#60a5fa', 
                fontFamily: 'monospace', 
                fontSize: '0.875rem',
                wordBreak: 'break-all'
              }}>
                {resetToken}
              </div>
            </div>
          )}

          <Link 
            to="/login"
            style={{
              display: 'inline-block',
              padding: '0.75rem 2rem',
              borderRadius: '8px',
              background: 'linear-gradient(135deg, #60a5fa 0%, #a78bfa 100%)',
              color: '#fff',
              textDecoration: 'none',
              fontWeight: '600'
            }}
          >
            Back to Sign In
          </Link>
        </div>
      </div>
    );
  }

  return (
    <AuthForm
      title="Reset Password"
      fields={fields}
      onSubmit={handleSubmit}
      submitText="Send Reset Link"
      error={error}
      loading={loading}
      footer={footer}
    />
  );
};

export default ForgotPasswordPage;

